/* tslint:disable */
/* eslint-disable */
/**
 * Quotes Management API
 * API for managing quotes
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Qui la plateforme prélève pour les cotisations. SOUSCRIPTEUR (défaut) : le souscripteur du devis. COURTIER : le cabinet du courtier connecté (courtier encaisseur), seulement si le tunnel l'autorise. BENEFICIAIRE : l'unique bénéficiaire du dossier du devis, seulement si le dossier en a exactement un. Le débiteur du mandat est déduit par le back de cette valeur.
 * @export
 */
export const MandatePayer = {
    Souscripteur: 'SOUSCRIPTEUR',
    Courtier: 'COURTIER',
    Beneficiaire: 'BENEFICIAIRE'
} as const;
export type MandatePayer = typeof MandatePayer[keyof typeof MandatePayer];


export function instanceOfMandatePayer(value: any): boolean {
    for (const key in MandatePayer) {
        if (Object.prototype.hasOwnProperty.call(MandatePayer, key)) {
            if (MandatePayer[key as keyof typeof MandatePayer] === value) {
                return true;
            }
        }
    }
    return false;
}

export function MandatePayerFromJSON(json: any): MandatePayer {
    return MandatePayerFromJSONTyped(json, false);
}

export function MandatePayerFromJSONTyped(json: any, ignoreDiscriminator: boolean): MandatePayer {
    return json as MandatePayer;
}

export function MandatePayerToJSON(value?: MandatePayer | null): any {
    return value as any;
}

export function MandatePayerToJSONTyped(value: any, ignoreDiscriminator: boolean): MandatePayer {
    return value as MandatePayer;
}

